
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}},[_c('path',{attrs:{"d":"M28.941 31.786L.613 60.114a2.014 2.014 0 102.848 2.849l28.541-28.541 28.541 28.541c.394.394.909.59 1.424.59a2.014 2.014 0 001.424-3.439L35.064 31.786 63.41 3.438A2.014 2.014 0 1060.562.589L32.003 29.15 3.441.59A2.015 2.015 0 00.593 3.439l28.348 28.347z"}})])
      }
    
      }
    